import { atom } from 'recoil'
import localStorageEffect from './effects/localStorageEffect'

export const factoryPicker = atom<string | undefined>({
  key: 'FactoryPicker',
  default: undefined,
  effects: [localStorageEffect('current_factory')],
})
